export type DevicesReturn = {
  success: boolean;
  tracks?: MediaStreamTrack[];
  mediaStream?: MediaStream;
  errorName?: string;
  message?: string;
};

export enum MediaTypes {
  AUDIO = "audiooutput",
  MIC = "audioinput",
  CAM = "videoinput",
}
